// social.js — Liens communautaires officiels, centralisés et configurables par env.
// ============================================================================
// Point 9 (zéro URL en dur) + point 12 (écosystème/communauté) : toutes les apps
// et composants sociaux lisent d'ici. Renseigner les REACT_APP_* dans le .env
// (exposés au build par Create React App via le préfixe REACT_APP_).

const env = process.env;

export const social = {
  youtube: env.REACT_APP_YOUTUBE_CHANNEL_URL || 'https://www.youtube.com/@VertinGo-e4c',
  discord: env.REACT_APP_DISCORD_URL || '',
  facebook: env.REACT_APP_FACEBOOK_PAGE_URL || '',
  twitter: env.REACT_APP_TWITTER_URL || '',
  reddit: env.REACT_APP_REDDIT_URL || '',
  tiktok: env.REACT_APP_TIKTOK_URL || '',
};

// Bouton "S'abonner" YouTube (ouvre la boîte d'abonnement).
export const subscribeUrl = () =>
  social.youtube ? `${social.youtube}?sub_confirmation=1` : '';

// URLs de partage vers les réseaux, pour une page/fiche donnée.
export const shareUrls = (url, title = '') => {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(title);
  return {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}`,
    twitter: `https://twitter.com/intent/tweet?url=${u}&text=${t}`,
    reddit: `https://www.reddit.com/submit?url=${u}&title=${t}`,
  };
};

// Formations Udemy (liens d'affiliation) — mises en avant dans l'écosystème.
export const udemyCourses = [
  { name: 'AWS Solutions Architect (FR)', url: 'https://www.udemy.com/course/aws-solutions-architect-associate-en-francais-preparation/?referralCode=0EFD148AA4D34B73E8FE' },
  { name: 'Terraform Associate (FR)', url: 'https://www.udemy.com/course/terraform-en-francais-certification-associate-003/?referralCode=F068BA4AA84CABBBC8C6' },
  { name: 'CKAD Kubernetes (FR)', url: 'https://www.udemy.com/course/ckad-en-francais-4-tests-blancs-160-qcm-corriges/?referralCode=45A683AA935DF62BD0EE' },
];

// N'affiche que les liens réellement configurés (évite les liens morts).
export const activeCommunityLinks = () =>
  [
    { key: 'youtube', label: 'YouTube', url: subscribeUrl() },
    { key: 'discord', label: 'Discord', url: social.discord },
    { key: 'facebook', label: 'Facebook', url: social.facebook },
    { key: 'twitter', label: 'Twitter / X', url: social.twitter },
    { key: 'reddit', label: 'Reddit', url: social.reddit },
  ].filter((l) => l.url);
